import cx from 'classnames';
import { bool, arrayOf, shape, number, func, string } from 'prop-types';
import { campaignState } from '../../../utils/campaignState';
import ProductContainerCustomizations from '../SharedComponents/ProductContainer/ProductContainerCustomizations';
import * as classNames from './CustomizePanel.module.css';
import CustomizeSidebar from './CustomizeSidebar/CustomizeSidebar';

const NotExpiredOpenParticipant = (props) => {
  const {
    displaySidebar,
    isMobile,
    items,
    viewAll,
    initialDisplayAmount,
    select,
    isProspect,
    displayOrderSummary,
    getExtraChoiceCount,
    boxData,
    cartSum,
    userData,
    displayViewButton,
    displayUpsellCta,
    toggleViewAll,
    status,
    pageItems,
  } = props;

  const productGridWrapperClassName = cx({
    [classNames.productGridWrapperWithSidebar]: !isMobile && displaySidebar,
    [classNames.productGridWrapper]: !isMobile && !displaySidebar,
  });

  return (
    <div
      className={cx(classNames.panelContainer, {
        [classNames.mobile]: isMobile,
      })}
    >
      <div className={productGridWrapperClassName}>
        <ProductContainerCustomizations
          open={status === campaignState.OPEN}
          products={isMobile ? pageItems : items}
          viewAll={viewAll}
          initialDisplayAmount={initialDisplayAmount}
          isSelect={select}
          isMobile={isMobile}
          isProspect={isProspect}
        />
      </div>
      {displaySidebar && (
        <CustomizeSidebar
          displayOrderSummary={displayOrderSummary}
          getExtraChoiceCount={getExtraChoiceCount}
          boxData={boxData}
          cartSum={cartSum}
          userData={userData}
          displayViewButton={displayViewButton}
          displayUpsellCta={displayUpsellCta}
          viewAll={viewAll}
          toggleViewAll={toggleViewAll}
        />
      )}
    </div>
  );
};

NotExpiredOpenParticipant.propTypes = {
  displaySidebar: bool.isRequired,
  isMobile: bool.isRequired,
  items: arrayOf(shape({})).isRequired,
  viewAll: bool.isRequired,
  initialDisplayAmount: number.isRequired,
  select: bool.isRequired,
  isProspect: bool.isRequired,
  displayOrderSummary: bool.isRequired,
  getExtraChoiceCount: func.isRequired,
  boxData: shape({}).isRequired,
  cartSum: number.isRequired,
  userData: shape({}).isRequired,
  displayViewButton: bool.isRequired,
  displayUpsellCta: bool.isRequired,
  toggleViewAll: func.isRequired,
  status: string.isRequired,
  pageItems: arrayOf(shape({})).isRequired,
};

export default NotExpiredOpenParticipant;
